import { Loader } from "@googlemaps/js-api-loader";

let loaderPromise: Promise<typeof google> | null = null;

const apiKey = process.env["NX_PUBLIC_GOOGLE_MAPS_API_KEY"];

if (!apiKey) {
  throw new Error("NX_PUBLIC_GOOGLE_MAPS_API_KEY is not defined");
}

const loader = new Loader({
  apiKey,
  version: "weekly",
  libraries: ["places"],
  language: "pl",
});

export const ensureGoogleMapsLoaded = async (): Promise<typeof google> => {
  if (!loaderPromise) {
    loaderPromise = loader.load();
  }
  return loaderPromise;
};
